'use client';
import EditIcon from '@/components/icons/Action/EditIcon';
import MenuIcon from '@/components/icons/Action/Menu';
import PersonCircledIcon from '@/components/icons/User/PersonCircledIcon';
import useNavigate from '@/hooks/useNavigate';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { toggle } from '@/store/slices/confSlice';
import { clearSte } from '@/store/slices/steSlice';
import { Brand } from '@/types/Brand';
import { globalLogout } from '@/utils/LogoutUtils';
import getEnv from '@/utils/env';
import { FormEvent, useEffect, useState } from 'react';
import styles from './style.module.scss';

export default function Header({ brand }: { brand: Brand }) {
  const dispatch = useAppDispatch();
  const selectedSte = useAppSelector((state) => state.selectedSte.societe);
  const [isMin, setIsMin] = useState(false);
  const profil = getEnv().PROFIL;
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  function changeIcon() {
    if (window.innerWidth <= 568) setIsMin(true);
    else setIsMin(false);
  }

  useEffect(() => {
    changeIcon();
    window.addEventListener('resize', changeIcon);

    return () => {
      window.removeEventListener('resize', changeIcon);
    };
  }, []);

  const logout = (e: FormEvent) => {
    e.preventDefault();
    globalLogout({ brand, navigate, dispatch });
  };

  return (
    <div className={styles['container']}>
      <MenuIcon
        onClick={() => dispatch(toggle())}
        className={styles['menuIcon']}
      />
      <div className={styles['logo-container']}>
        {isMin ? (
          <img
            src={'/icon/brand-min/' + brand + '.svg'}
            className={`${styles.logoMin} ${styles[brand]}`}
          />
        ) : (
          <img
            src={'/icon/brand/' + brand + '.svg'}
            className={`${styles.logo} ${styles[brand]}`}
          />
        )}
        <div className={styles['line']}></div>
        <h3 className={styles['txt']}>{selectedSte.name}</h3>
        {isAuthenticated && profil == 'PF' && (
          <EditIcon
            onClick={() => {
              dispatch(clearSte());
              navigate('');
            }}
            className={styles['editIcon']}
          />
        )}
      </div>
      {isAuthenticated && (
        <div className={styles['user']}>
          <h5 className={styles['fullname']}>
            {userInfo?.given_name} {userInfo?.family_name}
          </h5>
          <div
            title="Déconnecter"
            className={styles['logoutButton']}
            onClick={logout}
          >
            <PersonCircledIcon className={styles['userIcon']} />
          </div>
        </div>
      )}
    </div>
  );
}
